/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Summary_Bar_RateInputs */



/**
* | output |
* | --- |
* | "Reading Rate Bar" |
*
* @param {Options_Metrics_Summary_Bar_RateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_summary_bar_rate = /** @type {((inputs?: Options_Metrics_Summary_Bar_RateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Summary_Bar_RateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reading Rate Bar")
	if (locale === "de") return /** @type {LocalizedString} */ ("Reading Rate Bar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reading Rate Bar")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Reading Rate Bar")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reading Rate Bar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Reading Rate Bar")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Reading Rate Bar")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Reading Rate Bar")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reading Rate Bar")
	return /** @type {LocalizedString} */ ("Reading Rate Bar")
});